import { Link } from '@mui/material';
import { t } from '@ankr.com/common';

import {
  AAPI_JS_SDK,
  AAPI_PYTHON_SDK,
  ANKR_DOCS_LINKS,
} from 'modules/common/constants/const';

import { useAAPILinksStyles } from './useAAPILinksStyles';

interface AAPILinksProps {
  hasSupportedChainsLink?: boolean;
}

export const AAPILinks = ({ hasSupportedChainsLink }: AAPILinksProps) => {
  const { classes } = useAAPILinksStyles();

  return (
    <div className={classes.root}>
      <div className={classes.links}>
        {hasSupportedChainsLink && (
          <Link
            target="_blank"
            variant="body3"
            className={classes.link}
            href={ANKR_DOCS_LINKS.aapiSupportedChains}
          >
            {t('advanced-api.chain-overview.supported-chains')}
          </Link>
        )}
        <Link
          target="_blank"
          variant="body3"
          className={classes.link}
          href={AAPI_JS_SDK}
        >
          {t('advanced-api.chain-overview.js-sdk')}
        </Link>
        <Link
          target="_blank"
          variant="body3"
          className={classes.link}
          href={AAPI_PYTHON_SDK}
        >
          {t('advanced-api.chain-overview.python-sdk')}
        </Link>
        <Link
          target="_blank"
          variant="body3"
          className={classes.link}
          href={ANKR_DOCS_LINKS.aapiReactHooks}
        >
          {t('advanced-api.chain-overview.react-hooks')}
        </Link>
      </div>
    </div>
  );
};
